import { formatDate, formatTime } from '@/utils/format';

export interface CheckinOccurrenceRow {
  id: string;
  programId: string;
  programName: string | null;
  programKind: 'service' | 'program' | null;
  programStartsOn: string | null;
  programEndsOn: string | null;
  occurrenceDate: string;
  startsAt: string;
  endsAt: string;
  venueName: string | null;
  dayDetailId: string | null;
  gpsAutoCheckInEnabled?: boolean;
}

export const isMultiDayProgram = (row: CheckinOccurrenceRow): boolean =>
  row.programKind === 'program' &&
  Boolean(row.programStartsOn) &&
  Boolean(row.programEndsOn) &&
  row.programStartsOn !== row.programEndsOn;

export const formatCheckinSessionWhen = (row: CheckinOccurrenceRow, locale: string): string => {
  const time = formatTime(row.startsAt, { locale });
  const venue = row.venueName ? ` · ${row.venueName}` : '';
  return `${formatDate(row.occurrenceDate, { locale, style: 'medium' })} · ${time}${venue}`;
};

export const formatCheckinProgramRange = (
  row: CheckinOccurrenceRow,
  locale: string,
  multiDayRangeLabel: (start: string, end: string) => string,
): string | null => {
  if (!isMultiDayProgram(row) || !row.programStartsOn || !row.programEndsOn) return null;
  return multiDayRangeLabel(
    formatDate(row.programStartsOn, { locale, style: 'medium' }),
    formatDate(row.programEndsOn, { locale, style: 'medium' }),
  );
};

export const formatCheckinWhenLine = (
  row: CheckinOccurrenceRow,
  locale: string,
  multiDayRangeLabel: (start: string, end: string) => string,
): string => {
  const sessionWhen = formatCheckinSessionWhen(row, locale);
  const range = formatCheckinProgramRange(row, locale, multiDayRangeLabel);
  if (range) return `${range} · ${sessionWhen}`;
  return sessionWhen;
};
